import { FC } from "react";
import { NewsOverviewTypes } from "../../types/NewsTypes";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "@/routes/siteRoutesList";
import {
  Box,
  Card,
  Inset,
  Text,
  AspectRatio,
  Heading,
  Flex,
  Separator,
  Avatar,
  Skeleton,
} from "@radix-ui/themes";
import DateObject from "react-date-object";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import useSingleZone from "@/features/zones/hooks/useSingleZone";

const SingleNewsCard: FC<NewsOverviewTypes> = (props): JSX.Element => {
  const navigate = useNavigate();

  const { zoneItem, loading } = useSingleZone(props?.zone);

  const createdInMilliseconds =
    props.created.seconds * 1000 + props.created.nanoseconds / 1000000;
  const date = new DateObject({ date: new Date(createdInMilliseconds) });

  return (
    <Skeleton loading={loading}>
      <Box
        minHeight="100%"
        onClick={() => {
          navigate(props.slug);
        }}
      >
        <Card className="card" style={{ minHeight: "100%", height: "100%" }}>
          <Inset clip="padding-box" side="top" pb="current">
            <AspectRatio ratio={16 / 9}>
              <img src={props.imageURL} alt={props.title} />
            </AspectRatio>
          </Inset>

          <Flex gap="3" direction="column">
            <Box>
              <Text size="1" color="gray" as="p" mb="2">
                {date.format("DD. MMMM YYYY")}
              </Text>
              <Heading as="h2" size="4" truncate title={props.title} mb="1">
                {props.title}{" "}
              </Heading>

              <Text as="p" size="2" color="gray" truncate>
                {props.intro}
              </Text>
            </Box>

            <Separator style={{ width: "100%" }} />

            <Flex align="center" gap="3">
              <Avatar
                src={
                  props.zone && zoneItem
                    ? zoneItem.imageURL
                    : props.author.profileLogoUrl
                    ? props.author.profileLogoUrl
                    : brand.siteIcon
                }
                fallback={props.author?.userName.slice(0, 1)}
                radius="full"
                size="1"
              />

              <Text size="1" color="gray">
                {props.zone && zoneItem
                  ? zoneItem.title
                  : props.author?.userName
                  ? props.author.userName
                  : brand.name}
              </Text>
            </Flex>
          </Flex>
        </Card>
      </Box>
    </Skeleton>
  );
};
export default SingleNewsCard;
